import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  activeLanguage: "it",
  availableLanguages: ["en", "it"],
  isLoading: false,
  error: null,
};

export const languageSlice = createSlice({
  name: "language",
  initialState,
  reducers: {
    changeLanguage(state, action) {
      state.activeLanguage = action.payload;
      state.error = null;
    },
    setAvailableLanguages(state, action) {
      state.availableLanguages = action.payload;
    },
    setLoading(state, action) {
      state.isLoading = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
      state.isLoading = false;
    },
    clearError(state) {
      state.error = null;
    },
  },
});

export const languageActions = languageSlice.actions;
export default languageSlice.reducer;
